import { render, staticRenderFns } from "./ProductDescriptionDetailed.vue?vue&type=template&id=146408bc&scoped=true"
import script from "./ProductDescriptionDetailed.vue?vue&type=script&lang=ts"
export * from "./ProductDescriptionDetailed.vue?vue&type=script&lang=ts"
import style0 from "./ProductDescriptionDetailed.vue?vue&type=style&index=0&id=146408bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146408bc",
  null
  
)

export default component.exports